export const randomId = () => `temp-${Math.random().toString(36).substr(2, 9)}`;
